<template>
  <div>
    <Aguarde :show="showAguarde"></Aguarde>
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-12">
          <b-form>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Nome" label-for="pes_nome">
                  <h5 v-if="!alteracao.nome" class="mb-0">{{ usuario.pes_nome }}
                    <button type="button" @click="alterConfirmacao('nome')" title="Alterar Nome"
                            class="btn btn-outline-light btn-sm mr-0 mb-0">
                      <i class="bx bxs-edit-alt"></i>
                    </button>
                  </h5>
                  <input class="form-control"
                         v-else
                         v-model="usuario.pes_nome"
                         maxlength="150"
                         :class="{ 'is-invalid': $v.usuario.pes_nome.$error }"
                         id="pes_nome" type="text">
                  <div v-if="$v.usuario.pes_nome.$error" class="invalid-feedback">
                    Informe o nome completo do usuário
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="CPF" label-for="pes_cpfcnpj">
                  <h5 v-if="usuario.pes_cpfcnpj.length < 12" class="mb-0">
                    {{ usuario.pes_cpfcnpj | VMask('###.###.###-##') }}</h5>
                  <h5 v-else class="mb-0">{{ usuario.pes_cpfcnpj | VMask('##.###.###/####-##') }}</h5>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label-for="aut_status" label="Status">
                  <select id="aut_status" v-model="usuario.aut_status"
                          class="custom-select"
                          :class="{'is-invalid': $v.usuario.aut_status.$error }"
                          type="text">
                    <option value="A">Ativo</option>
                    <option value="I">Inativo</option>
                  </select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="E-mail" label-for="pes_mail">
                  <h5 v-if="!alteracao.email" class="mb-0">{{ usuario.pes_mail }}
                    <button type="button" @click="alterConfirmacao('email')" title="Alterar E-mail"
                            class="btn btn-outline-light btn-sm mr-0 mb-0">
                      <i class="bx bxs-edit-alt"></i>
                    </button>
                  </h5>
                  <input class="form-control"
                         v-model="usuario.pes_mail"
                         v-else
                         maxlength="80"
                         :class="{ 'is-invalid': $v.usuario.pes_mail.$error }"
                         id="pes_mail" type="email">
                  <div v-if="$v.usuario.pes_mail.$error" class="invalid-feedback">
                    Informe um e-mail válido
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Tipo de Acesso">
                  <select id="mes_competencia" v-model="usuario.aut_access"
                          class="custom-select"
                          :class="{'is-invalid': $v.usuario.aut_access.$error }"
                          type="text">
                    <option value="P">Usuário</option>
                    <option value="A">Administrador</option>
                  </select>
                  <div v-show="usuario.aut_access === 'A'" class="text-danger font-weight-bold">
                    Usuário com acesso total
                  </div>
                </b-form-group>
              </div>
              <div v-show="usuario.aut_access === 'A'" class="col-md-3">
                <b-form-group class="text-white" label="'">
                  <h3 class="text-danger">Administrador</h3>
                </b-form-group>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-12">
                <button type="button" @click="alterConfirmacao('senha')" title="Alterar E-mail"
                        class="btn btn-outline-light btn-sm mr-0 mb-0">
                  <i class="bx bxs-edit-alt"></i> Clique aqui para alterar senha
                </button>
              </div>
            </div>

            <div v-if="alteracao.senha" class="row">
              <div class="col-md-6">
                <b-form-group
                    id="password-group"
                    label="Senha"
                    label-for="password_new">
                  <div class="input-group mb-3">
                  <input
                      id="password_new"
                      autocomplete="off"
                      v-model="usuario.aut_senha"
                      v-bind:type="showPassword?'text':'password'"
                      class="form-control"
                      placeholder="Utilize letras, números e caracteres especiais">
                    <div class="input-group-append">
                      <label class="input-group-text">
                        <a style="cursor: pointer" @click="altershowPassword()" class="is-link">
                          <i v-show="!showPassword" class="fa fa-eye-slash" aria-hidden="true"></i>
                          <i v-show="showPassword" class="fa fa-eye" aria-hidden="true"></i>
                        </a>
                      </label>
                    </div>
                  </div>
                  <div v-show="usuario.aut_senha" class="mt-2 progress">
                    <div role="progressbar" v-show="passwordStrength.score <= 5" aria-valuemin="0"
                         aria-valuemax="30"
                         aria-valuenow="27" class="progress-bar bg-danger" style="width: 30%;">Péssima
                    </div>
                    <div role="progressbar" v-show="passwordStrength.score > 2" aria-valuemin="0" aria-valuemax="35"
                         aria-valuenow="35" class="progress-bar bg-warning" style="width: 35%;">Fraca
                    </div>
                    <div role="progressbar" v-show="passwordStrength.score > 3" aria-valuemin="0" aria-valuemax="35"
                         aria-valuenow="7" class="progress-bar bg-success" style="width: 35%;">Boa
                    </div>
                  </div>
                  <div class="text-muted">
                    Para o administrador é permitido informar qualquer nível de senha, entretanto senha <b>Péssima ou
                    Fraca</b> tem o
                    risco maior de comprometer a segurança do sistema.
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group
                    id="password-reply-group"
                    label="Repita a senha"
                    label-for="password">
                  <div class="input-group mb-3">
                  <input
                      id="password-reply"
                      autocomplete="off"
                      v-model="usuario.aut_senha_reply"
                      v-bind:type="showPassword?'text':'password'"
                      class="form-control"
                      placeholder="">
                    <div class="input-group-append">
                      <label class="input-group-text">
                        <a style="cursor: pointer" @click="altershowPassword()" class="is-link">
                          <i v-show="!showPassword" class="fa fa-eye-slash" aria-hidden="true"></i>
                          <i v-show="showPassword" class="fa fa-eye" aria-hidden="true"></i>
                        </a>
                      </label>
                    </div>
                  </div>
                  <div v-show="senhaDiferentes" class="text-danger">
                    As senhas não coincidem
                  </div>
                </b-form-group>
              </div>
            </div>

            <div v-if="false" class="row">
              <div class="row">
                <h5 class="mb-3 ml-3">Telefones</h5>
              </div>
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Número.</th>
                      <th>Ramal</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="e in list_telefone" v-bind:key="e.tel_codigo">
                      <td>{{ e.tab_nome }}</td>
                      <td>
                        <span v-if="e.tab_numero===1">{{ e.tel_numero | VMask('(##) ##### - ####') }}</span>
                        <span v-else>{{ e.tel_numero | VMask('(##) #### - ####?#') }}</span>
                      </td>
                      <td>{{ e.tel_contato }}</td>
                      <td class="text-right">
                        <button type="button" @click="removeTelefone(e)" class="btn btn-outline-primary btn-sm mr-3"><i
                            class="bx bxs-edit"></i>Editar
                        </button>
                        <button type="button" @click="removeTelefone(e)" class="btn btn-outline-danger btn-sm"><i
                            class="bx bxs-trash"></i>Excluir
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-form-group class="mt-2 text-right">
                  <button type="button" @click="saveUsuario()"
                          title="Reenviar e-mail de confirmação"
                          class="btn btn-success mr-2 mb-2">
                    <i class="bx bx-check-double"></i> Salvar
                  </button>
                  <button type="button" @click="voltar()" title="Editar Usuário"
                          class="btn btn-outline-dark mr-2 mb-2">
                    <i class="bx bx-arrow-back"></i> Voltar
                  </button>
                </b-form-group>
              </div>
            </div>

          </b-form>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import zxcvbn from 'zxcvbn';
import {required, email} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import {getUsuario, saveUsuario} from "@/api/admin/pessoas/pessoas";

export default {
  components: {
    Loader,
    Aguarde
  },
  computed: {
    passwordStrength() {
      if (this.usuario.aut_senha) {
        return zxcvbn(this.usuario.aut_senha);
      }
      return 0;
    },
    senhaDiferentes() {
      return (this.usuario.aut_senha !== this.usuario.aut_senha_reply);
    }
  },
  data() {
    return {
      showAguarde: false,
      httpSend: false,
      cpfInvalido: false,
      showPassword: false,
      usuario: {
        pes_nome: '',
        pes_cpfcnpj: '',
        pes_mail: null,
        aut_status: null,
        aut_access: null,
        aut_senha: '',
        aut_senha_reply: ''
      },
      list_telefone: [],
      alteracao: {
        nome: false,
        email: false,
        senha: false
      },
    };
  },
  validations: {
    usuario: {
      pes_nome: {
        required,
      },
      pes_cpfcnpj: {
        required,
      },
      pes_mail: {
        required,
        email
      },
      aut_status: {
        required,
      },
      aut_access: {
        required,
      }
    },
  },
  created() {
    if (this.$route.params.hash) {
      this.getUsuario();
    }
  },
  methods: {
    altershowPassword() {
      this.showPassword = !this.showPassword;
    },
    getUsuario() {
      this.httpSend = true;
      getUsuario(this.$route.params.hash).then(result => {
        if (result.status) {
          this.usuario = result.dados.usuario;
          this.list_telefone = result.dados.telefones;
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    saveUsuario() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      if (this.senhaDiferentes) {
        return false;
      }
      this.showAguarde = true;
      saveUsuario(this.usuario).then(result => {
        if (result.status) {
          this.$toast.success(result.mensagem)
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.showAguarde = false;
      })
    },
    alterConfirmacao(id) {
      this.alteracao[id] = !this.alteracao[id];
    },
    voltar() {
      this.$router.push({name: "admin-pessoas-usuarios"})
    }
  }
};
</script>

